import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

function MenuLevel({ content, level, slug = "" }) {
  let contentArr = Object.values(content);
  const location = useLocation();

  return contentArr.map((item, i) => {
    if (item.showinmenu === "false") return null;
    let menuItemClasses = "";
    if (level === 0) {
      menuItemClasses = "header--menu-list-item";
      if (location.pathname.substring(1).split("/")[0] === item.slug) {
        menuItemClasses += " is-active";
      }
    } else {
      menuItemClasses = `header--menu-submenu-item level-${level}`;
      menuItemClasses +=
        location.pathname.substring(1) === item.id ? " is-active" : "";
    }

    return (
      <div className={menuItemClasses} key={i}>
        <Link to={`/${item.uri}`} state={{ preFilter: "" }}>
          {item.title}
        </Link>
        {(((item.pagetype === "list" || item.pagetype === "blog") &&
          item.filterInMenu) ||
          item.children) && (
          <div className="header--menu-submenu">
            {(item.pagetype === "list" || item.pagetype === "blog") &&
              item.filterInMenu && (
                <>
                  {item.filterInMenu.sort().map((filterItem, j) => {
                    return filterItem !== "" ? (
                      <div
                        className={`header--menu-submenu-item level-${level}`}
                        key={j}
                      >
                        <Link
                          to={`/${item.uri}`}
                          state={{ preFilter: filterItem }}
                        >
                          {filterItem}
                        </Link>
                      </div>
                    ) : null;
                  })}
                  {item.pagetype === "blog" ? (
                    <div className={`header--menu-submenu-item level-${level}`}>
                      <Link to={"/archiv"}>Archiv</Link>
                    </div>
                  ) : null}
                </>
              )}
            {item.children && (
              <MenuLevel
                content={item.children}
                level={level + 1}
                slug={item.slug}
              />
            )}
          </div>
        )}
      </div>
    );
  });
}

function Menu(props) {
  let [content] = useState(props.content);

  if (content) {
    let menuHTMLItems = <MenuLevel content={content} level={0} />;
    return (
      <div className="header--menu">
        <div className="header--menu-list">{menuHTMLItems}</div>
      </div>
    );
  }
  return null;
}

export default Menu;
